import { WMTableColumnShape } from '../WMTable/WMTable';
import { filterRows, sort } from './helpers';
import { useMemo } from 'react';
import { AppTableFilter, IAppTableRowData, ITableData } from '../model';

export const useFilterSortData = (
    {
        data,
        tableData,
        environmentId,
        filtersList,
        searchTerm,
        searchMethod,
        searchKeys,
        columns
    }: {
        data?: IAppTableRowData[];
        tableData: ITableData;
        environmentId: string;
        filtersList: { [key: string]: AppTableFilter[] };
        searchTerm?: string;
        searchMethod: (items: IAppTableRowData[], searchTerm: string | undefined, keys: string[]) => typeof items;
        searchKeys: string[];
        columns: WMTableColumnShape[];
    },
    { skip = false }: { skip?: boolean } = {}
): IAppTableRowData[] => {
    return useMemo(() => {
        if (skip) {
            return data || [];
        }

        const sortedData = sort({
            data,
            term: tableData.sorting.dataKey,
            direction: tableData.sorting.direction,
            environmentId,
            filters: tableData.filters
        });
        const filtered = filterRows(sortedData, filtersList, columns);
        return searchMethod(filtered, searchTerm, searchKeys);
    }, [
        data,
        tableData.sorting.dataKey,
        tableData.sorting.direction,
        tableData.filters,
        environmentId,
        filtersList,
        columns,
        searchMethod,
        searchTerm,
        searchKeys,
        skip
    ]);
};
